export class NCSample {

    _id: string;

    lab: string;

    labName: string;

    dryProblem: boolean;

    sampleDate: Date;

    puid: string;

    sender: string;

    sampleType: SampleType;

    boxID: string;

    barcode: string;

    documentBarcode: string;

    customerBarcode: string;

    ncBarcode: string;

    problem: string;

    problemList: string[];

    comments: string;

    customerResponse: CustomerResponse;

    duplicateBarcode: string;

    receptionDate: Date;

    reported: Date;

    creationDate: any;

    actionTakenOn: Date;

    altAddBarCode : string;

    duplicated : boolean;

    mergeGroup: string;

    status: string;

    sourceProcess: string;

}

export enum SampleType {
	DRY,
    WET,
    SALIVA
}

export enum CustomerResponse {
	PROCESS_FURTHER,
    DISCARD,
    PROCESSED,
    WAIT,
    RESCUE,
    REMOVE
}

export interface SelectableSampleType {
    name: string,
    value: SampleType;
}

export interface SelectableCustomerResponse {
    name: string,
    value: CustomerResponse;
}
export class NCSampleFetchDTO {
  _id: string;
  lab: string;
  sampleDate: any;
  sender: string;
  barcode: string;
  customerResponse: CustomerResponse;
  status: string;
}
